import React, { lazy } from 'react';

const SwitchModeButton = lazy(() => import('../../app_components/ReviewProof/SwitchModeButton'));
const Page = lazy(() => import('../../app_components/ReviewProof/Page'));
const GetReviewImage = lazy(() => import('../../app_components/ReviewProof/GetReviewImage'));

function PagesRoute() {
  return (
    <>
      <Page>
        <GetReviewImage />
      </Page>
    </>
  );
}

export default PagesRoute;
